<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="31.902"
    height="19.485"
    viewBox="0 0 31.902 19.485"
  >
    <g transform="translate(-1102.553 -615.876)">
      <g transform="translate(1102.553 621.667)">
        <path
          d="M1122.746,634.634h-20.193l.032-.611a65.351,65.351,0,0,1,1.282-9.916l.581.034.222-.165a4.679,4.679,0,0,0,1.084.969c.674.507,2.026-.343,2.736-.909l-1.005-3.1.94.435a46.661,46.661,0,0,1,5.335,2.91,18.406,18.406,0,0,0,4.4,1.787,14.11,14.11,0,0,1,3.774,1.546c1.965,1.436.95,6.386.906,6.595Zm-19.252-1.144h18.571c.236-1.408.457-4.128-.572-4.876a13.878,13.878,0,0,0-3.545-1.431,18.853,18.853,0,0,1-4.583-1.874,46.421,46.421,0,0,0-4.294-2.4l.505,1.556-.292.265c-.26.229-2.567,2.274-3.975,1.211-.33-.247-.584-.457-.78-.634a63.806,63.806,0,0,0-1.035,8.183Z"
          transform="translate(-1102.553 -620.94)"
        />
        <rect
          width="19.583"
          height="1.144"
          transform="translate(0.661 9.745)"
        />
        <rect
          width="3.155"
          height="1.142"
          transform="translate(8.318 5.66) rotate(-60.477)"
        />
        <rect
          width="2.841"
          height="1.144"
          transform="translate(10.114 6.488) rotate(-59.203)"
        />
      </g>
      <path
        d="M1122.422,628.363a.567.567,0,0,1-.351-.12,6.549,6.549,0,0,1-2.451-6.2c.583-4.116,5.594-4.972,5.807-5.005a.571.571,0,0,1,.183,1.128c-.044.008-4.393.76-4.858,4.048a5.408,5.408,0,0,0,2.019,5.127.571.571,0,0,1-.35,1.022Z"
        transform="translate(2.438 0.165)"
      />
      <path
        d="M1125.292,629.209a.572.572,0,0,1-.09-1.136c.044-.008,4.391-.76,4.858-4.048a5.408,5.408,0,0,0-2.021-5.125.572.572,0,0,1,.7-.9,6.545,6.545,0,0,1,2.451,6.2c-.583,4.116-5.594,4.972-5.806,5.005A.517.517,0,0,1,1125.292,629.209Z"
        transform="translate(3.183 0.287)"
      />
      <path
        d="M1124.611,619.919a.572.572,0,0,1-.365-1.012l1.1-.916-1.5-1.081a.572.572,0,1,1,.67-.926l2.093,1.512a.572.572,0,0,1,.031.9l-1.67,1.388A.571.571,0,0,1,1124.611,619.919Z"
        transform="translate(3.024 0)"
      />
      <path
        d="M1126.214,629.447a.57.57,0,0,1-.335-.108l-2.093-1.513a.572.572,0,0,1-.031-.9l1.67-1.387a.572.572,0,1,1,.731.879l-1.1.917,1.5,1.08a.572.572,0,0,1-.335,1.035Z"
        transform="translate(3.014 1.368)"
      />
      <path
        d="M1124.236,624.846l-.055,0a.574.574,0,0,1-.4-.219l-1.627-2.094a.571.571,0,1,1,.9-.7l1.257,1.616,3.075-2.683a.572.572,0,0,1,.752.862l-3.531,3.08A.573.573,0,0,1,1124.236,624.846Z"
        transform="translate(2.797 0.681)"
      />
    </g>
  </svg>
</template>
